export const INIT_TREE = 'INIT_TREE';
export const GET_VERSION_LIST = 'GET_VERSION_LIST';
export const GET_INIT_VERSION_NAME = 'GET_INIT_VERSION_NAME';
export const SET_OPERATE_LIST = 'SET_OPERATE_LIST';
export const SET_OPERATEUSERNAME = 'SET_OPERATEUSERNAME';



// WEBPACK FOOTER //
// ./src/store/mutation_type.js